import React, { useState } from "react";
import { AlertAccountModal } from "./AlertAccountModal";
import { Mail } from "lucide-react";

export function AlertAccountSettings() {

    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <div className="card oct_analysis-card-v2 w-100 mb-0 oct_alert-account-banner-v2">
                <div className="oct_alert-account-content-v2">
                    <Mail className="oct_icon" />
                    <span>
                        Make sure you have a mailing account set up
                    </span>
                </div>
                <button
                    className="oct_settings-btn-v2"
                    onClick={() => setShowModal(true)}
                >
                    Mail Account Settings
                </button>
            </div>
            {showModal && <AlertAccountModal closeModal={() => setShowModal(false)} />}
        </>
    )

}